<div class="userrow card gap-12 col w100" i18n>
    <div class="lane1">
        <div class="col gap-8">
            <div class="row gap-8">
                <div class="strong">
                    {{ activeFounder.prename }}
                    {{ activeFounder.lastname }}
                </div>
            </div>
            <div>
                {{ activeFounder.email }} | Accepted:
                {{ activeFounder.connectionCreated | date }}
            </div>
        </div>
        <div class="btnarea row gap-8 align-center">
            <rr-btn
                type="Link"
                size="Small"
                (click)="revokeAccess(activeFounder)"
                >Revoke Access</rr-btn
            >
            <rr-btn
                type="Secondary"
                size="small"
                (click)="showDetails(activeFounder)"
                >Details</rr-btn
            >
        </div>
    </div>
    <rr-divider></rr-divider>
    <div class="lane2 space-between w100">
        <div class="row gap-16 align-center">
            <rr-badge tone="success">Access Status: Granted</rr-badge>

            @if (activeFounder.status === 'CONFIRM') {
                <rr-badge>Status: Pending</rr-badge>
            }
            @if (activeFounder.userGateProgress) {
                <rr-badge tone="information">User with Gates</rr-badge>
            }
        </div>
        <div class="row gap-16 align-center">
            @if (checkIfUserWaitsOnGate()) {
                <rr-badge tone="error">User waits on Gate</rr-badge>
            }
        </div>
    </div>
</div>
